<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="isCoach ? '채팅 정보' : '멤버톡 정보'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll; background-color: #fff;">
            <div style="gap: 4px; position: relative;">
                <div :style="thumbnail" style="height: 197px; position: relative; overflow: hidden; display: flex; align-items: center;">
                    <img @click="showImageViewer($event)" style="width: 100%; object-fit: cover;" :src="thumbnail" alt="">
                    <div v-if="chat.type != JOIN_CHAT_TYPE.OPEN && isMeCreator" @click="changeThumbnail" style="position: absolute; right: 0; bottom: 0;">
                        <img style="width: 40px;" :src="require('@/assets/img/modify_image.png')" alt="">
                        <input type="file" style="display:none;" accept="image/*" @change="readURL($event)" ref="imageFile">
                    </div>
                </div>
            </div>
            <div style="margin-top: 20px; padding: 0 20px;">
                <div @click="modifyMemberTalkName(); $Util.sendEventClick('멤버톡_설정_이름수정')" style="display: flex; align-items: center; gap: 12px; margin-bottom: 20px;">
                    <div>
                        <img style="width: 24px;" :src="require('@/assets/img/setting_title.png')" alt="">
                    </div>
                    <div style="flex: 1;">
                        <div class="title_wrap">
                            <div class="title">{{ isCoach ? '채팅방' : '멤버톡' }} 제목</div>
                            <!-- <div @click="modifyMemberTalkName(); $Util.sendEventClick('멤버톡_이름_수정')" class="modify">수정</div> -->
                        </div>
                        <div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">{{ memberTalkDetail.title }}</div>
                        </div>
                    </div>
                    <div v-if="isMeCreator">
                        <img style="width: 10px;" :src="require('@/assets/img/arrow_tick.png')" alt="">
                    </div>
                </div>
                <div @click="modifyMemberTalkIntro(); $Util.sendEventClick('멤버톡_설정_소개수정')" style="display: flex; align-items: center; gap: 12px; margin-bottom: 20px;">
                    <div>
                        <img style="width: 24px;" :src="require('@/assets/img/setting_intro.png')" alt="">
                    </div>
                    <div style="flex: 1;">
                        <div class="title_wrap">
                            <div class="title">{{ isCoach ? '채팅방 설명' : '멤버톡 소개' }}</div>
                            <!-- <div @click="modifyMemberTalkName(); $Util.sendEventClick('멤버톡_이름_수정')" class="modify">수정</div> -->
                        </div>
                        <div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">{{ memberTalkDetail.introduce }}</div>
                        </div>
                    </div>
                    <div v-if="isMeCreator">
                        <img style="width: 10px;" :src="require('@/assets/img/arrow_tick.png')" alt="">
                    </div>
                </div>
                <div v-if="!isCoach" @click="modifySetting(SETTING_TYPE.AGE); $Util.sendEventClick('멤버톡_설정_연령대수정')" style="display: flex; align-items: center; gap: 12px; margin-bottom: 20px;">
                    <div>
                        <img style="width: 24px;" :src="require('@/assets/img/setting_age.png')" alt="">
                    </div>
                    <div style="flex: 1;">
                        <div class="title_wrap">
                            <div class="title">연령대</div>
                            <!-- <div @click="modifyMemberTalkName(); $Util.sendEventClick('멤버톡_이름_수정')" class="modify">수정</div> -->
                        </div>
                        <div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">{{ memberTalkDetail.age }}</div>
                        </div>
                    </div>
                    <div v-if="isMeCreator">
                        <img style="width: 10px;" :src="require('@/assets/img/arrow_tick.png')" alt="">
                    </div>
                </div>
                <div v-if="!isCoach" @click="modifySetting(SETTING_TYPE.TAG); $Util.sendEventClick('멤버톡_설정_태그수정')" style="display: flex; align-items: center; gap: 12px; padding-bottom: 20px; border-bottom: 1px solid #ebebeb;">
                    <div>
                        <img style="width: 24px;" :src="require('@/assets/img/setting_tag.png')" alt="">
                    </div>
                    <div style="flex: 1;">
                        <div class="title_wrap">
                            <div class="title">멤버톡 태그</div>
                            <!-- <div @click="modifyMemberTalkName(); $Util.sendEventClick('멤버톡_이름_수정')" class="modify">수정</div> -->
                        </div>
                        <div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">{{ join_tag }}</div>
                        </div>
                    </div>
                    <div v-if="isMeCreator">
                        <img style="width: 10px;" :src="require('@/assets/img/arrow_tick.png')" alt="">
                    </div>
                </div>
                <div style="display: flex; align-items: center; gap: 12px; padding-top: 20px; margin-bottom: 20px; border-top: 1px solid #ebebeb;">
                    <div @click="showMemberList();">
                        <img style="width: 24px;" :src="require('@/assets/img/setting_join.png')" alt="">
                    </div>
                    <div @click="showMemberList(); $Util.sendEventClick('멤버톡_설정_참여인원자세히보기')" style="flex: 1;">
                        <div class="title_wrap">
                            <div class="title">참여 인원</div>
                            <!-- <div @click="modifyMemberTalkName(); $Util.sendEventClick('멤버톡_이름_수정')" class="modify">수정</div> -->
                        </div>
                        <div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">{{ memberTalkDetail.cur_cnt }}명</div>
                        </div>
                    </div>
                    <div>
                        <img style="width: 10px;" :src="require('@/assets/img/arrow_tick.png')" alt="">
                    </div>
                </div>
                <div style="margin-bottom: 40px;">
                    <template v-if="chat.type == JOIN_CHAT_TYPE.OPEN">
                        <div @click="showOutPersononChatPopup" style="width: 130px; height: 48px; line-height: 48px; border-radius: 12px; background-color: #f5f5f5; margin: 0 auto; text-align: center; color: var(--color-main); font-weight: 700; font-size: 14px;">오픈 멤버톡 나가기</div>
                    </template>
                    <template v-else>
                        <div v-if="isMeCreator" @click="showDeletePopup" style="width: 117px; height: 48px; line-height: 48px; border-radius: 12px; background-color: #f5f5f5; margin: 0 auto; text-align: center; color: var(--color-main); font-weight: 700; font-size: 14px;">{{ isCoach ? '채팅방' : '멤버톡' }} 삭제하기</div>
                        <div v-else @click="showExitPopup" style="width: 117px; height: 48px; line-height: 48px; border-radius: 12px; background-color: #f5f5f5; margin: 0 auto; text-align: center; color: var(--color-main); font-weight: 700; font-size: 14px;">{{ isCoach ? '채팅방' : '멤버톡' }} 나가기</div>
                    </template>
                </div>
            </div>
        </div>
        <CommonPopupFrame :isOpen="isOpenPopupFrame" :closeCompleteAction="closeOpenPopupFrame" :changeHeight="changeHeight" :changeHeightUnit="'px'">
            <div style="padding: 16px 20px;">
                <div @click="closeOpenPopupFrame" style="font-weight: 700; line-height: 24px;">닫기</div>
                <div v-if="popupType === 'exit'" style="font-weight: 700; font-size: 20px; line-height: 24px; text-align: center; margin-top: 32px;">{{ isCoach ? '채팅방에서 완전히 나갈까요?' : '멤버톡에서 완전히 나갈까요?' }}</div>
                <div v-else-if="popupType === 'delete'" style="font-weight: 700; font-size: 20px; line-height: 24px; text-align: center; margin-top: 32px;">{{ isCoach ? '채팅방을 완전히 삭제할까요?' : '멤버톡을 완전히 삭제할까요?' }}</div>
                <div v-else-if="popupType === 'openchat_getout'" style="font-weight: 700; font-size: 20px; line-height: 24px; text-align: center; margin-top: 32px;">오픈멤버톡을 완전히 나갈까요?</div>
                <div v-if="popupType === 'delete' && isCoach" style="margin-top: 20px; font-weight: 500; line-height: 24px; color: #606060; text-align: center;">이 채팅방은 다른 회원과 함께 쓰고 있습니다.<br>삭제하면 대화 기록은 전부 지워지며, 되돌릴 수 없어요.</div>
                <div v-if="popupType === 'exit' && isCoach" style="margin-top: 20px; font-weight: 500; line-height: 24px; color: #606060; text-align: center;">이 채팅방은 전문가의 초대로만 입장할 수 있습니다.<br>한 번 나가면, 다시 들어오기 어려울 수 있어요.</div>
                <div @click="exitJoin(); $Util.sendEventClick('멤버톡_정보_나가기')" v-if="popupType === 'exit'" style="margin-top: 40px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">확인</div>
                <div @click="deleteJoin(); $Util.sendEventClick('멤버톡_정보_삭제하기')" v-else-if="popupType === 'delete'" style="margin-top: 40px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">확인</div>
                <div @click="outPersonalChat(); $Util.sendEventClick('멤버톡_정보_오픈멤버톡_나가기')" v-else-if="popupType === 'openchat_getout'" style="margin-top: 40px; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">나가기</div>
            </div>
        </CommonPopupFrame>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="popMenuOptions"></BottomPopupMenu>
        <ModifyMemberTalkName v-if="isComplete" :isCoach="isCoach" :memberTalkIdx="memberTalkIdx" :memberTalkDetail="memberTalkDetail" :isOpen="isOpenModifyMemberTalkName" :closeCompleteAction="closeModifyMemberTalkName"></ModifyMemberTalkName>
        <ModifyMemberTalkIntro v-if="isComplete" :isCoach="isCoach" :memberTalkIdx="memberTalkIdx" :memberTalkDetail="memberTalkDetail" :isOpen="isOpenModifyMemberTalkIntro" :closeCompleteAction="closeModifyMemberTalkIntro"></ModifyMemberTalkIntro>
        <ModifyMemberTalkEnterType v-if="isComplete" :memberTalkIdxmemberTalkIdx="memberTalkIdx" :memberTalkDetail="memberTalkDetail" :isOpen="isOpenModifyMemberTalkEnterType" :closeCompleteAction="closeModifyMemberTalkEnterType"></ModifyMemberTalkEnterType>
        <ModifyMemberTalkDetail v-if="isComplete" :settingType="settingType" :memberTalkIdx="memberTalkIdx" :memberTalkDetail="memberTalkDetail" :isOpen="isOpenModifyMemberTalkDetailSetting" :closeCompleteAction="closeModifyMemberTalkDetailSetting"></ModifyMemberTalkDetail>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ModifyMemberTalkName from '@/components/modal/soccerjoin/ModifyMemberTalkName'
import ModifyMemberTalkIntro from '@/components/modal/soccerjoin/ModifyMemberTalkIntro'
import ModifyMemberTalkEnterType from '@/components/modal/soccerjoin/ModifyMemberTalkEnterType'
import ModifyMemberTalkDetail from '@/components/modal/soccerjoin/ModifyMemberTalkDetail'
import { JOIN_WAY, TOAST_TYPE, JOIN_CHAT_TYPE } from '../../../Constants'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import ResponseCode from '@/ResponseCode'
import CommonPopupFrame from "../my/CommonPopupFrame";

const PICTURE_TYPE = {
    THUMBNAIL: 'thumbnail',
    EMBLEM: 'emblem',
    COLLAGE: 'collage'
}

const SETTING_TYPE = {
    AGE: 'age',
    TAG: 'tag'
}

export default {
    name: 'MemberTalkSetting',
    components: { CommonPopupFrame, MercenaryHeader, BottomPopupMenu, ModifyMemberTalkName, ModifyMemberTalkIntro, ModifyMemberTalkEnterType, ModifyMemberTalkDetail },
    props: {
        memberTalkIdx: {
            type: [Number, String],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        chat: {
            type: Object,
            default: () => { }
        },
        memberTalkInfo: {
            type: Object,
            default: () => { }
        },
        refreshAction: {
            type: Function,
            default: () => { }
        },
        isCoach: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            JOIN_CHAT_TYPE: JOIN_CHAT_TYPE,
            memberTalkDetail: {},
            memberList: [],
            JOIN_WAY: JOIN_WAY,
            isOpenModifyMemberTalkName: false,
            isOpenModifyMemberTalkIntro: false,
            isOpenModifyMemberTalkEnterType: false,
            isOpenModifyMemberTalkDetailSetting: false,
            join_tag: '',
            joinAlram: false,
            isShowPopMenu: false,
            popMenuOptions: {},
            public_img_path: '',
            PICTURE_TYPE: PICTURE_TYPE,
            imagePath: '',
            isCollage: true,
            isComplete: false,
            settingType: SETTING_TYPE.AGE,
            SETTING_TYPE: SETTING_TYPE,
            isOpenPopupFrame: false,
            popupType: '',
            changeHeight: 232
        }
    },
    computed: {
        thumbnail() {
            if (this.chat.type == JOIN_CHAT_TYPE.OPEN) {
                const name = this.chat.name.split(' ')[0];
                return require('@/assets/nationwide_img/' + name + '.png');
            } else {
                return this.$resourcePath + this.memberTalkDetail.image_path
            }
        },
        isMeCreator() {
            return this.$GlobalStore.loginInfo().idx === this.memberTalkDetail.creator_idx
        }
    },
    methods: {
        async outPersonalChat() {
            const formData = new FormData();
            formData.append('chat_idx', this.chat.idx);

            const res = await this.$Axios.post('/api/chat/getout', formData);

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.showToast('오픈 멤버톡에서 나갔습니다.');
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        closeOpenPopupFrame() {
            this.isOpenPopupFrame = false;
        },
        showExitPopup() {
            this.popupType = 'exit';
            this.changeHeight = 306
            this.isOpenPopupFrame = true;
            this.$Util.sendEventClick('멤버톡_설정_멤버톡나가기');
        },
        showDeletePopup() {
            this.popupType = 'delete';
            if (this.isCoach) {
                this.changeHeight = 306
            }
            this.isOpenPopupFrame = true;
            this.$Util.sendEventClick('멤버톡_설정_멤버톡삭제하기');
        },
        showOutPersononChatPopup() {
            this.popupType = 'openchat_getout';
            this.isOpenPopupFrame = true;
            this.$Util.sendEventClick('멤버톡_설정_오픈멤버톡나가기');
        },
        async exitJoin() {
            const parameters = {};
            parameters.join_idx = this.memberTalkIdx;
            const res = await this.$Axios.post('/api/join/exit', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.closeLastModal();
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async deleteJoin() {
            const parameters = {};
            parameters.join_idx = this.memberTalkIdx;
            const res = await this.$Axios.post('/api/join/delete', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.closeLastModal();
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        showMemberList() {
            let memberTalkIdx = this.memberTalkIdx;
            let creator_member_idx = -1;
            let is_show_manager = true;
            if (this.chat.type == JOIN_CHAT_TYPE.OPEN) {
                memberTalkIdx = -1
                is_show_manager = false;
            } else {
                creator_member_idx = this.memberTalkDetail.creator.member_idx;
            }

            this.$GlobalStore.addModal('MemberTalkMemberList', {
                isCoach: this.isCoach, memberTalkIdx: memberTalkIdx, creatorIdx: creator_member_idx, is_show_manager: is_show_manager,
                chat : this.chat,
                completeAction: async () => {
                    await this.refresh();
                    // this.showMemberList();
                }
            })
        },
        modifySetting(settingType) {
            if (!this.isMeCreator) return;
            this.settingType = settingType
            this.isOpenModifyMemberTalkDetailSetting = true
        },
        readURL(e) {
            const input = e.currentTarget;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = () => {
                    this.saveModifyInfo(PICTURE_TYPE.THUMBNAIL)
                }
                reader.readAsDataURL(input.files[0]);
            }
        },
        changeDefaultImage() {
            let randomNum;
            let public_img_path;
            randomNum = parseInt(Math.random() * 30) + 1
            if (1 <= randomNum && randomNum < 10) {
                randomNum = '0' + randomNum
            }
            public_img_path = `/img/membertalk/membertalk_default_image_${randomNum}.jpg`
            this.public_img_path = public_img_path

            this.saveModifyInfo()
        },
        memberProfileCollage() {
            this.saveModifyInfo(PICTURE_TYPE.COLLAGE)
        },
        async saveModifyInfo(picture_type = false) {
            this.$GlobalStore.showProgress()
            const formData = new FormData()

            formData.append('mode', 'update')
            if (picture_type === PICTURE_TYPE.THUMBNAIL) {
                formData.append('file0', this.$refs.imageFile.files[0])
            }
            if (picture_type === PICTURE_TYPE.EMBLEM) {
                formData.append('file1', this.$refs.emblemImageFile.files[0])
            }
            if (picture_type === PICTURE_TYPE.COLLAGE) {
                formData.append('emblem_path', 'delete')
                formData.append('emblem_thumb_path', 'delete')
            }

            if (!picture_type) {
                formData.append('img_public_path', this.public_img_path)
            }

            formData.append('join_idx', this.memberTalkIdx)

            const res = await this.$Axios.post('/api/join/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.isShowPopMenu = false
                this.getMemberTalKDetail()
                this.completeModify()
                this.refreshAction()
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        changeThumbnail() {
            if (!this.isMeCreator) return;
            this.isShowPopMenu = true
            this.popMenuOptions = {
                labelAndAction: [
                    {
                        label: '기본 이미지로 변경', action: () => {
                            this.changeDefaultImage()
                        },
                    },
                    {
                        label: '앨범에서 선택', action: () => {
                            this.addFile()
                            this.isShowPopMenu = false
                        },
                    },

                ],
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        addFile() {
            this.$refs.imageFile.click();
        },
        addFileEmblem() {
            this.$refs.emblemImageFile.click();
        },
        roundBorder(i) {
            if (i === 0) {
                return { borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9' }
            }

            if (i === 1) {
                return { borderBottom: '1px solid #d9d9d9' }
            }

            if (i === 2) {
                return { borderRight: '1px solid #d9d9d9' }
            }
        },
        getImagePath(i) {
            if (this.memberList[i]) {
                return this.$resourcePath + this.memberTalkDetail.image_path
            }
        },
        showImageViewer(e) {
            const imagePath = e.currentTarget.getAttribute('src');
            this.$GlobalStore.addModal('MemberTalkImageViewer', { imagePath: imagePath, transitionName: 'bottom', status_bar_text_color: 'white' });
        },
        async getMemberTalKDetail() {
            const parameters = {}
            parameters.join_idx = this.memberTalkIdx;
            parameters.is_with_password = true;

            const res = await this.$Axios.get('/api/join/detail', { params: parameters })

            const memberTalkDetail = res.data.join_detail
            const memberTalkMembers = res.data.join_members

            this.memberTalkDetail = memberTalkDetail
            this.memberList = memberTalkMembers
            this.changeJoinTag(memberTalkDetail.join_tag.split(','))
            this.isCollage = this.memberTalkDetail.emblem_path ? false : true
            this.isComplete = true
        },
        changeJoinTag(tagList) {
            let joinTag = tagList
            let replaceTag = []
            for (let i = 0; i < joinTag.length; i++) {
                let result = joinTag[i].replace(/#/g, '')
                if (i === joinTag.length - 1) {
                    replaceTag.push(result)
                } else {
                    replaceTag.push(result + ' / ')
                }
            }
            joinTag = replaceTag
            this.join_tag = joinTag.join('')
        },
        modifyMemberTalkName() {
            if (!this.isMeCreator) return;
            this.isOpenModifyMemberTalkName = true
        },
        closeModifyMemberTalkName(modifyType, modifyTitle) {
            this.isOpenModifyMemberTalkName = false
            if (modifyType === 'title') {
                this.$set(this.memberTalkDetail, 'title', modifyTitle)
                this.completeModify()
            }
        },
        completeModify() {
            this.$GlobalStore.showToastVer2('멤버톡 정보를 저장했어요', TOAST_TYPE.CHECK)
        },
        modifyMemberTalkIntro() {
            if (!this.isMeCreator) return;

            this.isOpenModifyMemberTalkIntro = true
        },
        closeModifyMemberTalkIntro(modifyType, modifyIntro) {
            this.isOpenModifyMemberTalkIntro = false
            if (modifyType === 'intro') {
                this.$set(this.memberTalkDetail, 'introduce', modifyIntro)
                this.completeModify()
            }
        },
        closeModifyMemberTalkEnterType(modifyType, modifyEnterType) {
            modifyType; modifyEnterType;
            this.isOpenModifyMemberTalkEnterType = false
            this.completeModify()
            this.getMemberTalKDetail()
        },
        closeModifyMemberTalkDetailSetting(modifyType, age, maxCnt, tag) {
            age; maxCnt; tag;
            this.isOpenModifyMemberTalkDetailSetting = false
            if (modifyType === 'detail') {
                this.completeModify()
                this.getMemberTalKDetail()
            }
        },
        async alramOff() {
            this.joinAlram = !this.joinAlram
            const parameters = {}
            parameters.join_all = this.joinAlram ? '1' : '0'
            await this.$Axios.post('/api/setting/save', parameters)
        },
        async getMemberSetting() {
            const res = await this.$Axios.get('/api/setting/mine');
            this.joinAlram = res.data.setting.join_all == '1';
        },
        async getChatMembers() {
            const parameters = {};
            parameters.chat_idx = this.chat.idx;
            const res = await this.$Axios.get('/api/chat/members', { params: parameters });
            this.memberList = res.data.members;
            this.$set(this.memberTalkDetail, 'cur_cnt', res.data.members.length)
        },
        async refresh() {
            if (this.chat.type == JOIN_CHAT_TYPE.OPEN) {
                this.memberTalkDetail = {
                    title: this.chat.name,
                    age: '무관',
                    introduce: this.chat.name.split(' ')[0] + '모든 지역 오픈 멤버톡',

                }
                // this.memberTalkIdx = -1;
                this.join_tag = '지역 오픈 멤버톡';
                await this.getChatMembers();
            } else {
                await this.getMemberTalKDetail()
                await this.getMemberSetting()
            }
        }
    },
    created() {
        this.exitJoin = this.$Once(this.exitJoin);
        // this.outJoin = this.$Once(this.outJoin)
        this.saveModifyInfo = this.$Once(this.saveModifyInfo)
        this.alramOff = this.$Once(this.alramOff)
        this.outPersonalChat = this.$Once(this.outPersonalChat);
        this.refresh();
    }
}
</script>

<style scoped>
.title_wrap {}

.title_wrap .title {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}

.title_wrap .modify {
    font-weight: 500;
    font-size: 14px;
    color: var(--color-main);
}
</style>